import React from 'react'
import Breadcrumb from './Breadcrumb';

const SignHead = () => {
  return (
  //   <div class="site-breadcrumb">
  //   <div class="container">
  //     <h2 class="breadcrumb-title">Sign Up</h2>
  //     <ul class="breadcrumb-menu">
  //       <li><a href="index.html">Home</a></li>
  //       <li class="active">Sign Up</li>
  //     </ul>
  //   </div>
  //   <div class="hero-shape">
  //     <img 
  //     loading="lazy"
  //     role="presentation"
  //     decoding="async"
  //     fetchpriority="high"class="hero-shape-1" src="../../assets/img/shape/03.svg" alt=" " />
  //     <img 
  //     loading="lazy"
  //     role="presentation"
  //     decoding="async"
  //     fetchpriority="high"class="hero-shape-2" src="../../assets/img/shape/05.svg" alt=" " />
  //     <img 
  //     loading="lazy"
  //     role="presentation"
  //     decoding="async"
  //     fetchpriority="high"class="hero-shape-3" src="../../assets/img/shape/06.svg" alt=" " />
  //     <img 
  //     loading="lazy"
  //     role="presentation"
  //     decoding="async"
  //     fetchpriority="high"class="hero-shape-4" src="../../assets/img/shape/07.svg" alt=" " />
  //   </div>
  // </div>
  <div>
    <Breadcrumb
      title="Sign Up"
      path={[
        { label: "Home", href: "/", active: false },
        { label: "Sign Up", active: true }
      ]}
    />
</div>
  )
}

export default SignHead;
